import { createAction, props } from '@ngrx/store';
import { IBusinessPaymentRunDetailProducts } from '../dto/business-payment-run-detail-products.dto';

export const loadBusinessPaymentRunDetailProducts = createAction(
  '[BusinessPaymentRunDetailProduct] Load BusinessPaymentRunDetailProducts',
  props<{ request: { businessId: string; businessPaymentRunId: string } }>()
);

export const loadBusinessPaymentRunDetailProductsSuccess = createAction(
  '[BusinessPaymentRunDetailProduct] Load BusinessPaymentRunDetailProducts Success',
  props<{ response: IBusinessPaymentRunDetailProducts[] }>()
);

export const loadBusinessPaymentRunDetailProductsFailure = createAction(
  '[BusinessPaymentRunDetailProduct] Load BusinessPaymentRunDetailProducts Failure',
  props<{ error: Error | any }>()
);
